import { render } from "./MarketplacePayments1.vue?vue&type=template&id=39768181&lang=html"
import script from "./MarketplacePayments1.vue?vue&type=script&lang=js"
export * from "./MarketplacePayments1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__